module.exports = __webpack_public_path__ + "static/mobile-menu-background-f997345630dc782dd72d99a4aae26bf4.png";